'use client'
import { StateCreator } from 'zustand'

import { StoreState } from '@/domain/state/index'
export interface BannersVisibility {
  bannerVisibilityStatus: {
    [id: string]: boolean
  }
  closeBanner: (id: string) => void
}

export interface BannersVisibilitySlice {
  bannersVisibility: BannersVisibility
}

 
export const initBannersVisibilitySlice: StateCreator<StoreState, [], [], BannersVisibilitySlice> = (set) => ({
  bannersVisibility: {
    bannerVisibilityStatus: {},
    closeBanner: (id) => {
      set((state) => ({
        bannersVisibility: {
          ...state.bannersVisibility,
          bannerVisibilityStatus: {
            ...state.bannersVisibility.bannerVisibilityStatus,
            [id]: false,
          },
        },
      }))
    },
  },
})

export interface PersistedBannersSlice {
  bannersVisibility: {
    bannerVisibilityStatus?: {
      [id: string]: boolean
    }
  }
}

export function persistBannersVisibilitySlice(state: StoreState): PersistedBannersSlice {
  return {
    bannersVisibility: {
      bannerVisibilityStatus: state.bannersVisibility.bannerVisibilityStatus,
    },
  }
}
